import { AccountingReferencesDetailsQueryParams } from './useQueryAccountingReferencesDetails/types';
import { AnalyticsChartQueryParams } from './useQueryAnalyticsChart/types';
import { AnalyticsKpiQueryParams } from './useQueryAnalyticsKpi/types';
import { EsgDataQueryParams } from './useQueryEsgData/types';
import { SitesDetailsQueryParams } from './useQuerySitesDetails/types';
import { TopAccountingReferencesBreakdownQueryParams } from './useQueryTopAccountingReferencesBreakdown/types';
import { TopSitesBreakdownQueryParams } from './useQueryTopSitesBreakdown/types';
import { UserAnalyticsDetailsQueryParams } from './useQueryUserAnalyticsDetails/types';

/**
 * Query key factory for analytics-related queries.
 */
export const queryKeysAnalytics = {
  base: () => 'analytics' as const,
  getAccountingReferencesDetails: (
    queryParams: Partial<AccountingReferencesDetailsQueryParams>,
  ) =>
    [
      queryKeysAnalytics.base(),
      'accountingReference',
      'details',
      queryParams,
    ] as const,
  getChart: (queryParams: AnalyticsChartQueryParams) =>
    [queryKeysAnalytics.base(), 'chart', queryParams] as const,
  getEsgData: (queryParams: EsgDataQueryParams) =>
    [queryKeysAnalytics.base(), 'esg', 'data', queryParams] as const,
  getKpi: (queryParams: AnalyticsKpiQueryParams) =>
    [queryKeysAnalytics.base(), 'kpi', queryParams] as const,
  getSitesDetails: (queryParams: Partial<SitesDetailsQueryParams>) =>
    [queryKeysAnalytics.base(), 'site', 'details', queryParams] as const,
  getTopAccountingReferencesBreakdown: (
    queryParams: TopAccountingReferencesBreakdownQueryParams,
  ) =>
    [
      queryKeysAnalytics.base(),
      'costCenterSignatureRates',
      queryParams,
    ] as const,
  getTopAccountingReferencesBreakdownInfinite: (
    queryParams: TopAccountingReferencesBreakdownQueryParams,
  ) =>
    [
      queryKeysAnalytics.base(),
      'costCenterSignatureRates',
      'infinite',
      queryParams,
    ] as const,
  getTopSitesBreakdown: (queryParams: TopSitesBreakdownQueryParams) =>
    [queryKeysAnalytics.base(), 'siteSignatureRates', queryParams] as const,
  getTopSitesBreakdownInfinite: (queryParams: TopSitesBreakdownQueryParams) =>
    [
      queryKeysAnalytics.base(),
      'siteSignatureRates',
      'infinite',
      queryParams,
    ] as const,
  getUserDetails: (queryParams: Partial<UserAnalyticsDetailsQueryParams>) =>
    [queryKeysAnalytics.base(), 'user', 'details', queryParams] as const,
} as const;
